import { usePortalSession } from '../auth';

export function ProfilePage() {
  const { user } = usePortalSession();

  if (!user) {
    return null;
  }

  return (
    <section className="profile-page">
      <div className="profile-heading">
        <div>
          <p className="eyebrow">My profile</p>
          <h1>{user.displayName}</h1>
          <p className="hero-description">
            Profile information synchronized from Microsoft Entra ID.
          </p>
        </div>

        <span
          className={
            user.isAdministrator
              ? 'role-badge role-badge-admin'
              : 'role-badge'
          }
        >
          {user.isAdministrator
            ? 'Administrator'
            : 'Portal user'}
        </span>
      </div>

      <dl className="profile-details">
        <ProfileField label="Login ID" value={user.loginId} />
        <ProfileField label="Email" value={user.email} />
        <ProfileField
          label="Mobile phone"
          value={user.mobileNumber}
        />
        <ProfileField
          label="Organization"
          value={user.organization}
        />
        <ProfileField
          label="Identity type"
          value={user.identityType}
        />
      </dl>

      <p className="profile-note">
        Name, email, mobile phone and organization are updated
        from Entra when you sign in.
      </p>
    </section>
  );
}

function ProfileField({
  label,
  value,
}: {
  label: string;
  value: string | null;
}) {
  return (
    <div>
      <dt>{label}</dt>
      <dd>{value || 'Not registered'}</dd>
    </div>
  );
}
